import {
    setChecklistStatus,
    setChecklistError,
    setChecklistStep,
} from 'store/actions/Checklist'
import { performChecks } from 'store/thunks/Checklist'

import store from '../index'

const { dispatch } = store

export const dispatchSetChecklistStatus = payload =>
    dispatch(setChecklistStatus(payload))

export const dispatchSetChecklistError = payload =>
    dispatch(setChecklistError(payload))

export const dispatchChecks = payload => dispatch(performChecks(payload))

export const dispatchSetChecklistStep = payload =>
    dispatch(setChecklistStep(payload))
